import { render, staticRenderFns } from "./FileProcessingSummary.vue?vue&type=template&id=06b08889&scoped=true&"
import script from "./FileProcessingSummary.vue?vue&type=script&lang=js&"
export * from "./FileProcessingSummary.vue?vue&type=script&lang=js&"
import style0 from "./FileProcessingSummary.vue?vue&type=style&index=0&id=06b08889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b08889",
  null
  
)

export default component.exports